import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../remote/auth.service';

export const loginGuard: CanActivateFn = (route, state) => {
  const authtoken = inject(AuthService).getTokenFromLocalStorage();
  if (authtoken) {
    inject(Router).navigate(['/home']);
    return false;
  }
  return true;
};
